export class ClientProposalsDirectError extends Error {
    constructor(status, message) {
        super(message);
        this.status = status;
        this.name = "ClientProposalsDirectError";
    }
}
// Same runtime-hostname bug as calendar-api's resolveCalendarApiUrl (utils/calendarApiUrl.ts,
// fixed 2026-09-10): a hardcoded .env.development localhost URL resolves to the VIEWER's own
// machine, not the dev box, so it only ever worked testing from the same box the API runs on.
// When served through ui.<env>.offsetmind.com, client-proposals-api is real-routed at
// `/client-proposals-api` on that same host; only fall back to the static env value for
// genuinely local same-box access.
function baseUrl() {
    if (window.location.hostname.startsWith("ui.")) {
        return `${window.location.origin}/client-proposals-api`;
    }
    return window.__COREMIND_ENV__?.VITE_CLIENT_PROPOSALS_API_URL ?? "http://localhost:8811";
}
async function request(method, path, idToken) {
    const headers = { "Content-Type": "application/json" };
    if (idToken)
        headers["Authorization"] = `Bearer ${idToken}`;
    const res = await fetch(`${baseUrl()}${path}`, { method, headers });
    if (!res.ok) {
        let detail = res.statusText;
        try {
            const data = await res.json();
            detail = data?.detail ?? detail;
        }
        catch {
            // response body wasn't JSON -- keep the status text
        }
        throw new ClientProposalsDirectError(res.status, detail);
    }
    if (res.status === 204)
        return undefined;
    return res.json();
}
export const clientProposalsDirect = {
    listConversations: (idToken) => request("GET", "/conversations", idToken),
    claimConversation: (conversationId, idToken) => request("POST", `/conversations/${conversationId}/claim`, idToken),
    // Item 42's dashboard-table delete action.
    deleteConversation: (conversationId, idToken) => request("DELETE", `/conversations/${conversationId}`, idToken),
};
